var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods-editor"},[_c('FormList',{attrs:{"list":_vm.formList,"data":_vm.formData,"onChange":_vm.onInputChange}}),_c('ButtonRow',{attrs:{"firstText":"删 除","firstClick":_vm.deleteReceiver,"secondClick":_vm.saveReceiver,"bottom":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }